import Header from "./components/Header"
import CLBody from "./components/cuisineLocative/CLBody"
import CLSlidesClients from "./components/cuisineLocative/CLSlidesClients"
import FooterNew from "./components/FooterNew"

function CuisineLocative(){
    return(
        <>
        <div className="CLBackground">
            <Header/>
            <CLBody/>
            <CLSlidesClients/>
            <FooterNew/>
        </div>
        </>
    )
}

export default CuisineLocative